import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownBar() {
  const [timeLeft, setTimeLeft] = useState(10 * 60 + 48); // 10 minutes 48 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="fixed top-0 left-0 w-full bg-[#DC2626] text-white z-50 py-3 px-4 shadow-lg" data-id="element-42">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 md:gap-4 text-sm md:text-base font-bold uppercase tracking-wider" data-id="element-43">
        <Clock className="w-5 h-5 animate-pulse" data-id="element-44" />
        <span data-id="element-45">🔥 Esta oferta termina pronto:</span>
        <span className="bg-white text-[#DC2626] px-2 py-0.5 rounded font-mono text-lg min-w-[80px] text-center" data-id="element-46">
          {timeLeft > 0 ? `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}` : '¡Oferta expirada!'}
        </span>
      </div>
    </div>;
}